// ─── Scrollspy ───────────────────────────────────────────────────────────────

document.addEventListener('DOMContentLoaded', function () {
    const navLinks = document.querySelectorAll('.nav--content a[href^="#"]');
    if (!navLinks.length) return;

    // Section → alle zugehörigen Links (Desktop + Mobile Nav)
    const sectionMap = new Map();

    navLinks.forEach((link) => {
        const id = link.getAttribute('href').slice(1);
        const section = document.getElementById(id);
        if (!section) return;

        if (!sectionMap.has(section)) {
            sectionMap.set(section, []);
        }
        sectionMap.get(section).push(link);
    });

    if (!sectionMap.size) return;

    const setActive = (activeSection) => {
        navLinks.forEach((l) => l.classList.remove('is-active'));
        const links = sectionMap.get(activeSection);
        if (links) links.forEach((l) => l.classList.add('is-active'));
    };

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setActive(entry.target);
                }
            });
        },
        {
            rootMargin: '-10% 0px -10% 0px',
            threshold: 0,
        }
    );

    sectionMap.forEach((_, section) => observer.observe(section));
});

// ─── Telefonfeld in Kontaktformularen ────────────────────────────────────────
// Das Website-Theme im Kern startet initPhoneCountryFields nicht. Abgeschickt wird
// aber nur das versteckte Feld (input_phone), das sichtbare hat keinen name.
// Ohne Skript bleibt die Nummer leer, und als Pflichtfeld schlägt der Versand fehl.
// Hier wird die Eingabe 1:1 ins versteckte Feld kopiert, solange intl-tel-input fehlt.

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.js-phoneCountryField').forEach((inputPhone) => {
        const name = inputPhone.dataset.inputName;
        const inputGroup = inputPhone.closest('.inputGroup');
        const hiddenInput = name && inputGroup
            ? inputGroup.querySelector('input[type="hidden"][name="' + name + '"]')
            : null;
        if (!hiddenInput) return;

        const hasIntlTelInput = () =>
            window.intlTelInputGlobals && window.intlTelInputGlobals.getInstance(inputPhone);

        const sync = () => {
            if (hasIntlTelInput()) return;
            hiddenInput.value = inputPhone.value.trim();
        };

        // nach Fehlermeldung des Servers steht die Nummer nur im versteckten Feld
        if (!inputPhone.value && hiddenInput.value && !hasIntlTelInput()) {
            inputPhone.value = hiddenInput.value;
        }

        inputPhone.addEventListener('input', sync);
        inputPhone.addEventListener('change', sync);
        if (inputPhone.form) {
            inputPhone.form.addEventListener('submit', sync);
        }
    });
});
